module.exports = __webpack_public_path__ + "static/media/jess_bday.5c7ea81f.jpg";